import { useEffect, useRef } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import CustomTooltip from "../components/CustomTooltip";

const GoogleScholarBarChart = ({ scholarChartData }) => {
  const scrollRef = useRef(null);

  // Scroll to end when data changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
    }
  }, [scholarChartData]);

  return (
    <div
      ref={scrollRef}
      className="bg-white/10 rounded-xl overflow-x-auto scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-700"
      style={{ width: "100%", maxWidth: "600px", height: "320px" }} // height includes padding + chart
    >
      <div style={{ width: `${scholarChartData.length * 60}px`, height: "300px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={scholarChartData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#ccc" />
            <XAxis
              dataKey="year"
              stroke="#fff"
              tick={{ fill: "#fff", fontSize: 12 }}
              interval={0}
            />
            <YAxis
            orientation="right"
              stroke="#fff"
              tick={{ fill: "#fff", fontSize: 12 }}
              width={40}
            />
            <Tooltip content={<CustomTooltip />} />
            <Bar
              dataKey="count"
              fill="#FACC15"
              barSize={40}
              radius={[4, 4, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GoogleScholarBarChart;
